import React from "react";

import styles from "./SearchTap.module.scss";

type Props = {
  tap: { relatedSearch: string; tap: string };
  onClick(tap): void;
};

const SeachTap: React.FC<Props> = ({ tap, onClick }) => {
  const { tap: tapValue } = tap;

  const handleOnClick = () => {
    onClick(tap);
  };

  return (
    <div className={styles.searchTap} onClick={handleOnClick}>
      {tapValue}
    </div>
  );
};

export default SeachTap;
